import { atom } from "recoil";
import { RegistrationType } from "../hooks/useRegistrationFormSchema";

export const quizUser = atom<quizUserType>({
    key: 'quiz.user',
    default: undefined
})

export const isUserRegistered = atom<boolean>({
    key: 'quiz.isUserRegistered',
    default: false
})

export const isQuizSaved = atom<boolean>({
    key: 'quiz.isQuizSaved',
    default: false
})

export const quizTranslationState = atom< [quizTranslationType] | []>({
    key: 'quiz.TranslationState',
    default: []
})

export const quizLoaded = atom<quizLoadedType>({
    key: 'quiz.loaded',
    default: {}
})



type quizLoadedType = {
    data?: { [key: string]: any }
    name?: string
    id?: number
    depth?: number
}

type quizUserType = RegistrationType & { userId?: number} | undefined

export type quizTranslationType = {key: string, value: string}